import { render, staticRenderFns } from "./oilAccount.vue?vue&type=template&id=65f09d7c&scoped=true&"
import script from "./oilAccount.vue?vue&type=script&lang=js&"
export * from "./oilAccount.vue?vue&type=script&lang=js&"
import style0 from "./oilAccount.vue?vue&type=style&index=0&id=65f09d7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f09d7c",
  null
  
)

export default component.exports